/* eslint-disable react-hooks/rules-of-hooks */
/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/
/* eslint-disable no-unused-expressions */

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import { Form, Formik, Field } from 'formik';
import { FitinsurAPI, MessageCenter } from 'utils';
import Loader from 'components/Loader';
import Colors from 'constants/Colors';
import { Row, Col } from "components/Grid";
import Layout from 'components/Layout';
import BrokingSummary from 'components/BrokingSummary';
import Button, { ButtonContainer } from 'components/Button';
import ContentCard from 'components/ContentCard';
import TextField from 'components/Form/TextField';
import { RadioButtonGroup } from 'components/Form/Radio';
import { GlobalLoaderContext } from 'store/context';
import { GlobalAuthContext } from 'store/context';
import { Scrollbox, Footer, Title, ButtonContent } from './styles';
import { Label } from "components/Form";
import CheckBox from "components/Form/CheckBox";
import { LostCancelButton } from 'components/index'
import StepNavigation from 'components/StepNavigation/index';
import RenderButtons from 'components/RenderButtons';
import HasPermission from 'components/HasPermission/index';
import ModalConfirmation from "components/ModalConfirmation/index";
import { useOperationInfo } from 'services/OperationService'
import { useHeaderNbi, useBindMessage, useListStampsContacts } from 'services/QuoteService';

export default function StampRequestContacts(props) {
  const [summary, setSummary] = useState({});
  const [insurers, setInsurers] = useState([]);
  const [operationStatus, setOperationStatus] = useState(null);
  const [endorsmentType, setEndorsmentType] = useState("");
  const [time, setTime] = useState(null);
  const [selectedItems, setSelectedItems] = useState([]);
  // update issue 1404 - all endorsemnts types are enable to edit field Message External
  const [messageDisabled, setMessageDisabled] = useState(false);
  const [isMultipleContacts, setIsMultipleContacts] = useState(false);
  const [isBound, setIsBound] = useState(false);
  const [confirmationModal, setConfirmationModal] = useState(false);

  const loading = useContext(GlobalLoaderContext);
  const authContext = useContext(GlobalAuthContext);
  const formik = useRef(Formik);
  const history = useHistory();
  const mc = new MessageCenter();
  const fitinsur = new FitinsurAPI();

  const goToLoginPage = () => {
    history.push('/login');
  };

  const {
    data: useOperationInfoData,
    loading: useOperationInfoLoading,
    error: useOperationInfoError,
    status: useOperationInfoStatus,
    request: useOperationInfoRequest,
  } = useOperationInfo(props.match.params.idOperation);

  const {
    data: useHeaderNbiData,
    loading: useHeaderNbiLoading,
    error: useHeaderNbiError,
    status: useHeaderNbiStatus,
    request: useHeaderNbiRequest,
  } = useHeaderNbi();

  const {
    data: useListStampsContactsData,
    loading: useListStampsContactsLoading,
    error: useListStampsContactsError,
    status: useListStampsContactsStatus,
    request: useListStampsContactsRequest,
  } = useListStampsContacts(props.match.params.idOperation);

  const {
    data: useBindMessageData,
    loading: useBindMessageLoading,
    error: useBindMessageError,
    status: useBindMessageStatus,
    request: useBindMessageRequest,
  } = useBindMessage(props.match.params.idOperation);

  useEffect(() => {
    if (useOperationInfoLoading || useOperationInfoLoading || useBindMessageLoading || useListStampsContactsLoading) {
      loading.start();
    } else {
      loading.stop();
    }
  }, [useOperationInfoLoading, useOperationInfoLoading || useBindMessageLoading, useListStampsContactsLoading]);


  function handleSummary() {
    useHeaderNbiRequest({ idOperation: props.match.params.idOperation }, null).then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        history.goBack();
        return;
      }
      setSummary({
        typeOfCover: data.ret_value.typeOfCover,
        client: data.ret_value.client,
        obligorCoding: data.ret_value.obligorCoding,
        responseBy: data.ret_value.responseBy,
        internalContact: data.ret_value.internalContact,
        broker: data.ret_value.broker,
        dealCode: data.ret_value.deal,
        nmFacility: data.ret_value.nmFacility,
        nmObligor: data.ret_value.nmObligor,
        projectName: data.ret_value.projectName,
        idOperation: props.match.params.idOperation,
      });
      setEndorsmentType(data.ret_value.endorsmentType);

      // update issue 1404 - all endorsemnts types are enable to edit field Message External
      /* switch (data.ret_value.endorsmentType) {
        case 'cancellation':
        case 'not-pre-agreed':
          setMessageDisabled(true);
          break;
      } */
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleSummary.name}\n` + error);
        console.error('fitPostSummary - Error:', error);
      });
  };

  function requestBindMessage() {
    useBindMessageRequest().then(({ data: resp }) => {
      if (resp.ret_code !== 200) {
        mc.error(resp.ret_msg_details);
        history.goBack();
        return;
      }

      if (formik.current) {
        formik.current?.setFieldValue('message', resp.ret_value.stampMessage);
      }
    }).catch((error) => {
      mc.error("Erro executando consulta\n" + error);
      console.error('fitPostReject - Error:', error);
    });
  };

  function handleSelect(contact, insurer) {
    const select = { idPersonInsurer: insurer.idPersonInsurer, idContact: contact.idContact, email: contact.email, name: contact.nameContact };

    const alreadySelected = selectedItems.filter((item) => item.idPersonInsurer === select.idPersonInsurer);
    if ((isMultipleContacts && alreadySelected.length >= 2) || (!isMultipleContacts && alreadySelected.length >= 0)) {
      const filteredItems = selectedItems.filter((item) => item.idPersonInsurer !== select.idPersonInsurer);
      filteredItems.push(select);
      setSelectedItems(filteredItems);
    } else {
      setSelectedItems([...selectedItems, select]);
    };
  };

  function listContacts(idContactDepartment) {
    useListStampsContactsRequest(null, { idContactDepartment: idContactDepartment }).then(({ data }) => {
      if (data.ret_code !== 200) {
        mc.error(data.ret_msg_details);
        return;
      }
      setInsurers(data.ret_value.contacts.sort((a, b) => String(a?.nmInsurer).localeCompare(String(b?.nmInsurer))));
      setIsMultipleContacts(data.ret_value.multipleContacts)
    })
      .catch((error) => {
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  };

  function getStatusOperation() {
    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestValidatePolicyStampStatus(props.match.params.idOperation).then(response => response.json())
      .then(data => {

        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details || 'There was an error while processing your data');
          loading.stop();
          return;
        }

        setOperationStatus(data.ret_value.statusOperation?.toLowerCase());
        if (data.ret_value.errorMessage && data.ret_value.errorMessage.trim().length) {
          mc.error(data.ret_value.errorMessage || 'There was an error while processing your data')
          loading.stop();
          return
        }

        if (data.ret_value.statusOperation === 'created') return;

        setTimeout(() => {
          getStatusOperation();
        }, 30000);

      }).catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  }

  const handleContacts = (contacts) => {
    if (!insurers) {
      return;
    }
    const Arr = contacts.map(item => {
      return {
        label: `${item.nameContact}  :  ${item.email}.`,
        value: { email: item.email, idContact: item.idContact, nameContact: item.nameContact }
      }
    })
    return Arr;
  }

  const handleSubmit = (e, ignoreValidation) => {
    function groupByKey(array, key) {
      return array
        .reduce((hash, obj) => {
          if (obj[key] === undefined) return hash;
          return Object.assign(hash, { [obj[key]]: (hash[obj[key]] || []).concat(obj) })
        }, {})
    }

    if (!ignoreValidation) {
      if (!endorsmentType) {
        if (isMultipleContacts) {
          const contactsByInsurer = groupByKey(selectedItems, "idPersonInsurer");
          const multipleContactsValues = Object.values(contactsByInsurer);
          const multipleContactsValidation = multipleContactsValues.filter(v => v.length < 1)
          if (multipleContactsValidation.length || insurers.length !== multipleContactsValues.length) {
            mc.error('Please, select at least one contacts per party');
            return;
          }
        }

        const contactsByInsurer = groupByKey(selectedItems, "idPersonInsurer");
        const multipleContactsValues = Object.values(contactsByInsurer);
        if (insurers.length !== multipleContactsValues.length) {
          mc.error('Please, select at least one contact per insurer');
          return;
        }
      } else {
        if (!selectedItems?.length) {
          return mc.error('Please, select at least one contact');
        }

        if (isMultipleContacts) {
          const contactsByInsurer = groupByKey(selectedItems, "idPersonInsurer");
          const multipleContactsValues = Object.values(contactsByInsurer);
          const multipleContactsValidation = multipleContactsValues.filter(v => v.length < 1)
          if (multipleContactsValidation.length || insurers.length !== multipleContactsValues.length) {
            return setConfirmationModal(true);
          }
        }
      }
    }

    function normalizeEmail(email) {
      return (email == null ? '' : String(email)).trim().toLowerCase();
    }
    
    function hasDuplicateEmails(items) {
      const seen = new Set();
      for (const contact of items) {
        const key = normalizeEmail(contact.email);
        if (!key) continue;
        if (seen.has(key)) {
          return true;
        }
        seen.add(key);
      }
      return false;
    }
 
    if (hasDuplicateEmails(selectedItems)) {
      mc.error('You cannot select duplicate emails.');
      return;
    }

    function removeDuplicateContacts(contacts) {
      const seen = {};
      return contacts.filter(contact => {
        if (seen[contact.idContact]) {
          return false;
        }
        seen[contact.idContact] = true;
        return true;
      });
    }


    const uniqueSelectedItems = removeDuplicateContacts(selectedItems);
    
    loading.start();

    let body = {
      idOperation: props.match.params.idOperation,
      insurers: [...uniqueSelectedItems],
      contactsFormik: e.insurers,
      message: e.message,
      isMultipleContacts
    }

    fitinsur.setAuthToken(authContext.token);
    fitinsur.requestSendPolicyStamp(body.idOperation, body.insurers, body.message, body.isMultipleContacts)
      .then(response => response.json())
      .then(data => {

        if (data.ret_code !== 200) {
          mc.error(data.ret_msg_details);
          return;
        }

        setTimeout(() => {
          getStatusOperation()
        }, 2000);

      })
      .catch((error) => {
        loading.stop();
        mc.error("There was an error while fetching your data:  \n" + error);
        console.error('fitPostListContact - Error:', error);
      });
  }

  const title = () => {
    switch (endorsmentType) {
      case 'cancellation':
        return "ENDORSEMENT - CANCELLATION / CONTACTS SELECTION";

      case 'not-pre-agreed':
        return "ENDORSEMENT - ANNIVERSARY NOT PRE-AGREED / CONTACTS SELECTION";

      case 'adjustments-and-corrections':
        return "ENDORSEMENT - ADJUSTMENTS AND CORRECTIONS / CONTACTS SELECTION";

      case 'client-change':
        return "ENDORSEMENT - CLIENT CHANGE / CONTACTS SELECTION";

      default:
        return "STAMPS REQUEST - ELECTRONIC SIGNATURE";
    }
  };

  const renderMultipleContacts = insurers?.length ? insurers.map((insurer) => (
    <>
      <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
        <Title>
          {insurer.insurerFirstName}
        </Title>
      </Row>

      {insurer.contacts.length ? insurer.contacts.map((contact) => (
        <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
          <Col style={{ flexDirection: "row", display: "flex" }}>
            <label>
              <CheckBox
                onChange={() => handleSelect(contact, insurer)}
                checked={selectedItems.find((item) => item.idContact === contact.idContact) ? true : false}
                disabled={isBound}
              />
            </label>
            <Label>
              {contact.legalEntity}
            </Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.nameContact}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.personContactDepartment}</Label>
          </Col>
          <Col md={3} style={{ flexDirection: "row", display: "flex", alingItems: "start" }}>
            <Label>{contact.email}</Label>
          </Col>
        </Row>
      ))
        : (
          <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
            <Label>
              No results found.
            </Label>
          </Row>
        )
      }
    </>
  )) : (
    <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
      <Label>
        No results found.
      </Label>
    </Row>
  );

  async function handleOperationInfo() {
    useOperationInfoRequest().then(({ data: response }) => {
      setIsBound(response?.isBound);
    })
      .catch((error) => {
        mc.error(`There was an error while fetching your data: ${handleOperationInfo.name}\n` + error);
      });
  }

  useEffect(() => {
    if (formik) {
      insurers.forEach((insurer) => {
        const item = {
          IdPersonInsurer: insurer.idPersonInsurer,
          insurerFirstName: insurer.insurerFirstName,
          nmInsurer: insurer.nmInsurer,
          contact: null
        }

        if (formik.current) {
          formik.current?.setFieldValue(`${insurer.idPersonInsurer}`, item);
        }
      });
    }
  }, [insurers])

  useEffect(() => {
    fitinsur.setAuthToken(authContext.token);

    handleOperationInfo();
    handleSummary();
    listContacts();
    requestBindMessage();
  }, []);

  useEffect(() => {
    if (operationStatus === 'created') {
      clearInterval(time);
      history.push(`/broking/stamps-status-list/${props.match.params.idOperation}`);
      loading.stop();
    } else if (operationStatus === 'processing_error') {
      clearInterval(time);
      loading.stop();
    }
  }, [operationStatus]);

  return (
    <Layout idOperation={props.match?.params?.idOperation} title={summary.projectName ? summary.projectName : summary?.nmObligor ? summary?.nmObligor : "Broking name"} subtitle={summary?.dealCode ? summary?.dealCode : "Deal Code"}>
      <StepNavigation stage={3} idOperation={props.match?.params?.idOperation} />
      <Scrollbox>
        <BrokingSummary data={summary} />
        <ModalConfirmation
          text="Are you sure you want to proceed with the stamp request? Not all parties were selected."
          show={confirmationModal}
          onConfirm={() => {
            setConfirmationModal(false);
            handleSubmit(formik.current?.values, true)
          }}
          onCancel={() => {
            setConfirmationModal(false);
          }}
        />
        <ContentCard
          title={title()}
          icon
          info={{ idOperation: props.match?.params?.idOperation || null, idProduct: props.location?.state?.idProduct || null }}
          filterContact
          handleFilterContact={(idContactDepartment) => listContacts(idContactDepartment)}
        >
          <Formik
            innerRef={formik}
            initialValues={{}}
            onSubmit={(e) => handleSubmit(e)}
          >
            {formikProps => (
              <Form>
                <Row>
                  <Col md={12} sm={12}>
                    <Title>TO</Title>
                    {isMultipleContacts
                      ? renderMultipleContacts
                      : insurers.map((insurer, index) => (
                        <Col key={index} md={12}>
                          <Row style={{ flexDirection: "row", display: "flex", margin: "10px 0px 5px 10px" }}>
                            <Title>
                              {insurer.insurerFirstName}
                            </Title>
                          </Row>
                          <Row style={{ flexDirection: "row", display: "flex", marginLeft: "10px", marginRight: "0px" }}>
                            <Col>
                              <Field
                                key={insurer.idPersonInsurer}
                                style={{ marginTop: 10 }}
                                name={`${insurer.idPersonInsurer}`}
                                fieldName={insurer.insurerFirstName}
                                options={handleContacts(insurer.contacts)}
                                onChange={(e) => {
                                  handleSelect(e, insurer, index);
                                  formik.current?.setFieldValue(`${insurer.idPersonInsurer}.contact`, e)
                                }}
                                component={RadioButtonGroup}
                                isRequired
                              />
                            </Col>
                          </Row>
                        </Col>)
                      )
                    }
                    <Field
                      style={{ marginTop: 10 }}
                      label={'Message - (External)'}
                      name={'message'}
                      value={formikProps.values.message}
                      onChange={(e) => formikProps?.setFieldValue('message', e)}
                      component={TextField}
                      disabled={isBound}
                    />
                  </Col>
                </Row>

                <Footer>
                  <ButtonContainer>
                    <Button forth onClick={() => { history.goBack() }}>&lt; Back</Button>
                    <RenderButtons idOperation={props.match?.params?.idOperation}>
                      <HasPermission permission={!isBound}>
                        <ButtonContent>
                          <div style={{ marginTop: "5px" }}>
                            <LostCancelButton idOperation={props.match?.params?.idOperation} />
                          </div>
                          <HasPermission permission={props.permissions.EXECUTION}>
                            <Button primary type='submit' style={{ marginLeft: "10px", marginTop: "5px" }}>
                              STAMPS REQUEST
                            </Button>
                          </HasPermission>
                        </ButtonContent>
                      </HasPermission>
                    </RenderButtons>
                  </ButtonContainer>
                </Footer>
              </Form>
            )}
          </Formik>
          {loading.active && <Loader backdropColor={Colors.WHITE} fullScreen />}
        </ContentCard>
      </Scrollbox>
    </Layout>
  )
}
